import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Link2, ShieldOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/mcp-admin/google-ads/oauth`;
const fmt = (d) => (d ? new Date(d).toLocaleString("ro-RO") : "nefolosit încă");

export const McpOAuthGrants = ({ url }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => axios.get(API).then((r) => setItems(r.data.items)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  const revoke = async (g) => {
    if (!window.confirm(`Revoc conexiunea „${g.client_name}”? Claude va trebui să se reconecteze.`)) return;
    try { await axios.delete(`${API}/${g.id}`); toast.success("Conexiune revocată"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };
  return (
    <div className="space-y-2 rounded-lg border border-zinc-800 p-3" data-testid="mcp-oauth">
      <p className="flex items-center gap-2 text-xs font-medium text-zinc-200"><Link2 className="h-3.5 w-3.5 text-amber-400" /> Claude.ai — Custom Connector (OAuth)</p>
      <p className="text-[11px] text-zinc-500">În Claude.ai → Settings → Connectors → Add custom connector, lipește adresa de mai jos. Te logezi cu emailul și parola BragusApp, fără token.</p>
      <code className="block break-all rounded bg-zinc-950 px-3 py-2 font-mono text-[11px] text-zinc-300" data-testid="mcp-oauth-url">{url}</code>
      {!items.length ? <p className="text-[11px] text-zinc-500" data-testid="mcp-oauth-empty">Nicio conexiune OAuth activă.</p> : items.map((g) => (
        <div key={g.id} className="flex items-center gap-3 text-[11px]" data-testid={`mcp-oauth-grant-${g.id}`}>
          <span className="font-medium text-emerald-300">{g.client_name}</span>
          <span className="text-zinc-500">{g.scope.replaceAll("google-ads:", "")} · conectat {fmt(g.created_at)} · folosit {fmt(g.last_used_at)}</span>
          <button data-testid={`mcp-oauth-revoke-${g.id}`} onClick={() => revoke(g)} className="ml-auto inline-flex items-center gap-1 rounded-full border border-zinc-700 px-2 py-0.5 text-zinc-300 hover:border-rose-400"><ShieldOff className="h-3 w-3" /> Revocă</button>
        </div>))}
    </div>
  );
};
